import styled from 'styled-components';

export const ContainerTop = styled.section`
  display: flex;
  flex-direction: column;

  .first-content {
    display: grid;

    grid-template-columns: minmax(0, 1.4fr) minmax(0, 1fr);
    gap: 0.9375rem;
    align-items: start;

    > * {
      width: 100%;
      min-width: 0;
      box-sizing: border-box;
    }

    .conta-finalizadora {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 0.9375rem;
      margin-top: -0.5rem;

      > * {
        width: 100%;
        min-width: 0;
        box-sizing: border-box;
      }
    }
  }

  .second-content {
    display: grid;
    grid-template-columns: 12.5rem minmax(12rem, 0.5fr) 18.75rem auto;
    gap: 0.9375rem;
    align-items: end;

    > * {
      width: 100%;
      min-width: 0;
      box-sizing: border-box;
    }

    #conciliados {
      width: auto;
      justify-self: start;
      margin-top: 0.625rem;
    }
  }

  @media (max-width: 1200px) {
    .first-content {
      grid-template-columns: 1fr;
    }
    .first-content .conta-finalizadora {
      grid-template-columns: 1fr;
    }

    .second-content {
      grid-template-columns: 1fr;
      align-items: stretch;

      #conciliados {
        width: auto;
        justify-self: stretch;
      }
    }
  }
`;
